import React, { useContext, useState } from "react";
import { DeviceHubOutlined } from "@mui/icons-material";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";

const TopologicalButton: React.FC<IButtonProps> = ({ icon, title }) => {
  const { drawControl, map } = useContext(MapContext);
  const [topologicalEditing, setTopologicalEditing] = useState(drawControl.current?.options?.topologicalEditing || false);

  const handleToggleClick = () => {
    const newValue = !topologicalEditing;
    setTopologicalEditing(newValue);

    // Fire event to notify DrawHandler to update options
    map?.fire("draw.options_changed", { topologicalEditing: newValue });
  };

  return (
    <ToolbarToggleButton
      title={title || `${topologicalEditing ? "Disable" : "Enable"} topological editing`}
      value="topologicalEditing"
      onChange={handleToggleClick}
      selected={topologicalEditing}
      sx={{ height: 24 }}
    >
      {icon || <DeviceHubOutlined />}
    </ToolbarToggleButton>
  );
};

export default TopologicalButton;
